import styled from 'styled-components';
import { InputStyles } from './Input';

const Textarea = styled.textarea`
  ${InputStyles}
`;

export default Textarea;
